// extracted by mini-css-extract-plugin
export var container = "_5j-1";
export var cornerButtonContainer = "_5j-5";
export var disabled = "_5j-2";
export var fileContainer = "_5j-4";
export var hiddenInput = "_5j-3";
export var widthContainer = "_5j-0";